import React from "react";
import PageLayout from "../../components/PageLayout/PageLayout";

export default function DataProtection(props) {
  const { configuration } = props;

  return (
    <PageLayout configuration={configuration} title="Datenschutz">
      <section className="spg-section">
        <div className="spg-kicker">Rechtliches</div>
        <h2 className="spg-title">Datenschutzerklärung</h2>
        <div className="spg-legal" dangerouslySetInnerHTML={{ __html: configuration.dataProtectionText || '' }} />
      </section>
    </PageLayout>
  );
}
